export default __webpack_public_path__ + "media/images/content-dog-7858fa24dcf010703c1c94019bd4b0fe.svg";